import { ChannelTemplateCategory } from "./channel-template-category";

export class ChannelTemplate {
  constructor(
    public id: number,
    public title: string,
    public categories: Array<ChannelTemplateCategory>,
    public description: string,
    public trailerUrl: string = "",
  ) {}
}
